import { render, staticRenderFns } from "./HuesGrid.vue?vue&type=template&id=a66685a8&scoped=true&lang=pug&"
import script from "./HuesGrid.vue?vue&type=script&lang=ts&"
export * from "./HuesGrid.vue?vue&type=script&lang=ts&"
import style0 from "./HuesGrid.vue?vue&type=style&index=0&id=a66685a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66685a8",
  null
  
)

export default component.exports